var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2VideoNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1152,160H128a64,64,0,0,0-64,64V896a64,64,0,0,0,64,64H608a32,32,0,0,0,32-32V896a32,32,0,0,0-32-32H160V668.31L433.68,454.43l134.5,173.2A32,32,0,0,0,593.45,640H800.51a32,32,0,0,0,17-4.91L1120,444.84V608a32,32,0,0,0,32,32h32a32,32,0,0,0,32-32V224A64,64,0,0,0,1152,160ZM678,609.45,499.24,382.52A80.13,80.13,0,0,0,387.12,369L160,546.47V256h960v75.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.76,904.43l-255-145.71C821.09,734.34,768,765.14,768,814.28v291.44c0,49.14,53.09,79.94,95.75,55.56l255-145.71C1161.75,991,1161.75,929,1118.76,904.43Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2VideoNormal);
export default __webpack_public_path__ + "static/media/img2video_normal.1dd6c93f5fdd144f860bf325ee7785ee.svg";
export { ForwardRef as ReactComponent };